import { useQuery } from '@tanstack/react-query';
import api from '../../services/api';
import { Product } from './types';
import { ProductParams } from './useProducts';

const GET_SHOP_PRODUCT_BY_BAR_CODE = ['GET_SHOP_PRODUCT_BY_BAR_CODE'];

interface ShopProductByBarCodeResponse {
    data: Product[];
}

export type ShopProductByBarCodeResult = {
    id: number;
    name: string;
} | null;

export async function fetchShopProductByBarCode(barCode: string) {
    const params: Pick<ProductParams, 'barCode'> = { barCode };

    const response = await api.get<ShopProductByBarCodeResponse>('/product', {
        params,
    });

    return response.data.data.find((product) =>
        product.BarCodes.some((code) => code.code === barCode),
    );
}

export function useShopProductByBarCode(barCode: string) {
    const queryFn = async () => {
        const matchingProduct = await fetchShopProductByBarCode(barCode);

        return matchingProduct
            ? { id: matchingProduct.id, name: matchingProduct.name }
            : null;
    };

    return useQuery({
        queryFn,
        queryKey: [GET_SHOP_PRODUCT_BY_BAR_CODE, barCode],
        enabled: barCode.length > 0,
        refetchOnWindowFocus: false,
        retry: false,
    });
}
